import { defineStore } from 'pinia'

import { api } from '@/core/plugins/axios'
import { initFlow } from '@/features/auth/api/kratos'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    loading: true,
  }),
  getters: {
    isAuthenticated: (state) => !!state.user,
  },
  actions: {
    async fetchUser() {
      try {
        const res = await api.get(import.meta.env.VITE_AUTH_URL + '/sessions/whoami', {
          withCredentials: true,
        });
        this.user = res.data;
      } catch (e) {
        this.user = null;
      } finally {
        this.loading = false;
      }
    },
    async logout() {
      try {
        // Initialize logout flow to get the logout URL (proper Kratos way)
        const { data: flow } = await initFlow('logout');
        
        // Redirect to Kratos logout URL
        if (flow.logout_url) {
          this.user = null;
          window.location.href = flow.logout_url;
        } else {
          // Fallback: clear user and redirect to login
          this.user = null;
          window.location.href = import.meta.env.VITE_AUTH_URL + '/auth/login';
        }
      } catch (error) {
        console.error('Logout failed:', error);
        // Even if logout flow fails, clear user state and redirect
        this.user = null;
        window.location.href = import.meta.env.VITE_AUTH_URL + '/auth/login';
      }
    }
  }
})
